import { ComponentType } from 'react';

import { useAppSelector } from '../../../../../store/hooks';
import { OuterAppsFiltersProps } from '../models/outer-apps-filters.props';

export const withAppsFilterValues = <TProps extends OuterAppsFiltersProps>(
  WrappedComponent: ComponentType<TProps>
): ((props: Omit<TProps, 'selectedAppFilters'>) => JSX.Element) => {
  return (props: Omit<TProps, 'selectedAppFilters'>) => {
    const selectedAppFilters = useAppSelector(
      state => state.appsFeature.apps.filters.header
    );

    return (
      <WrappedComponent
        {...(props as TProps)}
        selectedAppFilters={selectedAppFilters}
      />
    );
  };
};
